export default defineNuxtRouteMiddleware((to, from) => {
    const authStore = useAuthStore();
    
    // Check if user is logged in
    if (!authStore.loggedIn) {
        // Redirect to login page
        return navigateTo('/auth/login');
    }

    // Check if user has a refresh token
    const refreshTokenCookie = useCookie('auth._refresh_token.pb');
    if (!refreshTokenCookie.value) {
        // No refresh token, redirect to login
        return navigateTo('/auth/login');
    }
});
